<template>
  <page-template pageTitle="Văn bản đến đã xử lý">
    <template #headerExtend>
      <filter-by-status-header
        ref="headerFilter"
        :filterStatus="filterStatus"
        :filterOptions="filterOptions"
        @filterByStatus="filterByStatus"
      />
    </template>

    <template #filter>
      <search-template-v2
        :keyword="keyword"
        @simpleSearch="simpleSearch"
        @search="isOpenAdvanceSearchDialog = true"
      >
        <template #quickFilter>
          <div
            class="flex-row flex-left__top margin-right-10 txt-center custom-label__input fix-width__large"
          >
            <span class="label-input width__auto">Ngày chuyển: </span>
            <el-date-picker
              v-model="sendTimeRange"
              type="daterange"
              format="dd/MM/yyyy"
              class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
              :picker-options="dateQuickFilterOption"
              range-separator="_"
              start-placeholder="_"
              end-placeholder="_"
              align="right"
              :clearable="false"
              @change="filterBySendTime"
            >
            </el-date-picker>
          </div>
        </template>
        <template #advance>
          <vbden-advance-search-dialog
            :isOpen="isOpenAdvanceSearchDialog"
            :form="advanceSearchForm"
            v-if="isEnableAdvanceSearchDialog"
            @dialogClosed="isEnableAdvanceSearchDialog = false"
            @closeDialog="isOpenAdvanceSearchDialog = false"
            @doSearch="advanceSearch"
          />
        </template>
      </search-template-v2>
    </template>

    <template #mainContent>
      <div class="barChart" ref="barChartContainerDiv">
        <el-table
          :data="incomingDocs"
          class="style-fullWidth"
          highlight-current-row
          sortable="custom"
          @sort-change="doSort"
          @row-click="viewDetail"
          ref="mainTable"
          :height="tableHeight"
        >
          <el-table-column type="index" fixed></el-table-column>

          <el-table-column
            property="quote"
            label="Trích yếu"
            min-width="200"
            sortable
            fixed
          >
            <template slot-scope="scope">
              <break-word-span
                :text="scope.row.quote"
                :maxLength="200"
              ></break-word-span>

              <br />

              <span v-if="scope.row.docCode"
                >#{{ scope.row.docCode }}&nbsp;&nbsp;</span
              >

              <el-tag v-if="scope.row.docTypeName"
                >{{ scope.row.docTypeName }}
              </el-tag>

              <doc-priority-tag
                :priorityName="scope.row.priorityName"
              ></doc-priority-tag>

              <doc-process-type-tag
                :processType="scope.row.vbDocProcessType"
              ></doc-process-type-tag>

              <doc-bcc-tag
                v-if="
                  scope.row.relationType ===
                  VB_DOC_USER.RELATION_TYPE.NGUOI_DUOC_BCC
                "
                :vbDocBccInfoId="scope.row.vbDocBccInfoId"
              ></doc-bcc-tag>
            </template>
          </el-table-column>

          <el-table-column
            property="docDate"
            label="Ngày văn bản"
            sortable
            align="right"
          >
            <template slot-scope="scope">
              {{
                scope.row.docDate
                  | dateFormatter({ nullValue: "-", dateFormat: "DD/MM/YYYY" })
              }}
            </template>
          </el-table-column>

          <el-table-column property="senderName" label="Người chuyển" sortable>
            <template slot-scope="scope">
              <break-word-span
                :text="scope.row.senderName"
                :maxLength="100"
              ></break-word-span>
            </template>
          </el-table-column>

          <el-table-column
            property="sendTime"
            label="Thời gian chuyển"
            sortable
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.sendTime | dateFormatter({ nullValue: "-" }) }}
            </template>
          </el-table-column>

          <el-table-column
            property="deadlineDate"
            label="Hạn xử lý"
            sortable
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.deadlineDate | dateFormatter({ nullValue: "-" }) }}
            </template>
          </el-table-column>

          <infinite-loading
            slot="append"
            ref="infiniteLoading"
            spinner="spiral"
            @infinite="infiniteHandler"
            force-use-infinite-wrapper=".el-table__body-wrapper"
          >
            <div slot="no-more"></div>
            <div slot="no-results"></div>
          </infinite-loading>
        </el-table>
      </div>

      <!--      <div class="header-title flex-row flex__between margin-bottom-10">-->
      <!--        <div class="leftSection flex-row flex__left">-->
      <!--          <div class="theTitle theTitle__lv5">-->
      <!--            <span class="stt margin-left-10">STT</span>-->
      <!--          </div>-->
      <!--          <div-->
      <!--            class="theTitle theTitle__lv1 flex-row flex__left clickable"-->
      <!--            @click="doSort('quote')"-->
      <!--          >-->
      <!--            Trích yếu-->
      <!--            <sort-caret :order="order" :sort="sort" :field="'quote'"/>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="rightSection flex-row flex__right">-->
      <!--          <div-->
      <!--            class="theTitle theTitle__lv3 flex-row flex__left clickable"-->
      <!--            @click="doSort('docDate')"-->
      <!--          >-->
      <!--            Ngày văn bản-->
      <!--            <sort-caret :order="order" :sort="sort" :field="'docDate'"/>-->
      <!--          </div>-->

      <!--          <div-->
      <!--            class="theTitle theTitle__lv2 flex-row flex__left"-->
      <!--            @click="doSort('senderName')"-->
      <!--          >-->
      <!--            Người chuyển-->
      <!--            <sort-caret :order="order" :sort="sort" :field="'senderName'"/>-->
      <!--          </div>-->

      <!--          <div-->
      <!--            class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"-->
      <!--            @click="doSort('sendTime')"-->
      <!--          >-->
      <!--            Thời gian chuyển-->
      <!--            <sort-caret :order="order" :sort="sort" :field="'sendTime'"/>-->
      <!--          </div>-->

      <!--          <div-->
      <!--            class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"-->
      <!--            @click="doSort('deadlineDate')"-->
      <!--          >-->
      <!--            Hạn xử lý-->
      <!--            <sort-caret :order="order" :sort="sort" :field="'deadlineDate'"/>-->
      <!--          </div>-->

      <!--          &lt;!&ndash;-->
      <!--          <div class="theTitle theTitle__lv3 flex-row flex__right padding-left-10">-->
      <!--            Hạn xử lý-->
      <!--            <i class="arrange-icon el-icon-d-caret" />-->
      <!--          </div>-->
      <!--          &ndash;&gt;-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <VuePerfectScrollbar-->
      <!--        class="scroll-area"-->
      <!--        :settings="perfectScrollbarSetting"-->
      <!--        infinite-wrapper-->
      <!--      >-->
      <!--        <div class="list-docs">-->
      <!--          <div-->
      <!--            v-for="(item, $itemIndex) in incomingDocs"-->
      <!--            v-bind:key="$itemIndex"-->
      <!--            class="item flex-row flex__between"-->
      <!--            @click="viewDetail(item)"-->
      <!--          >-->
      <!--            <div class="leftSection flex-row flex__left">-->
      <!--              <div class="theTitle__lv5">-->
      <!--                <div class="flex-row flex__left">-->
      <!--                  <div class="section-check">-->
      <!--                    &lt;!&ndash; <el-checkbox-->
      <!--                        v-model="checkAll"-->
      <!--                        class="select-doc margin-left-10 flex-row flex__center margin-top-10"-->
      <!--                      /> &ndash;&gt;-->
      <!--                    <span class="stt flex-row flex__center">{{-->
      <!--                      $itemIndex + 1-->
      <!--                    }}</span>-->
      <!--                  </div>-->
      <!--                  <fileTypeImage-->
      <!--                    :fileExtention="item.fileExtention"-->
      <!--                    class="clickable"-->
      <!--                    @click.native.stop="-->
      <!--                      downloadAttachment(item, ATTACHMENT_OBJECT_TYPE.VB_DEN)-->
      <!--                    "-->
      <!--                  />-->
      <!--                  &lt;!&ndash; <i class="fas fa-file color__silver"></i> &ndash;&gt;-->
      <!--                  &lt;!&ndash; {{item}} &ndash;&gt;-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <div class="theTitle__lv1 margin-right-10">-->
      <!--                <div class="title-docs flex-col flex__left">-->
      <!--                  <div class="tt_1 clickable">{{ item.quote }}</div>-->
      <!--                  <div class="tt_2 flex-row flex__left">-->
      <!--                    <span v-if="item.docCode"-->
      <!--                    >{{ item.docCode }}&nbsp;&nbsp;</span-->
      <!--                    >-->
      <!--                    <el-tag-->
      <!--                      v-if="item.docTypeName"-->
      <!--                      size="mini"-->
      <!--                      :class="['priority', 'lv3']"-->
      <!--                    >{{ item.docTypeName }}-->
      <!--                    </el-tag>-->

      <!--                    <el-tag-->
      <!--                      v-if="isShowPriority(item.priorityId)"-->
      <!--                      size="mini"-->
      <!--                      :class="['priority', getPiorityClass(item.priorityId)]"-->
      <!--                    >-->
      <!--                      <i class="fas fa-bolt"></i>-->
      <!--                      <span>-->
      <!--                        {{ item.priorityName }}-->
      <!--                      </span>-->
      <!--                    </el-tag>-->

      <!--                    <el-tag-->
      <!--                      v-if="item.vbDocProcessType != null"-->
      <!--                      size="mini"-->
      <!--                      :class="['priority', 'lv3']"-->
      <!--                    >-->
      <!--                      <i-->
      <!--                        :class="[-->
      <!--                          'fas',-->
      <!--                          getProcessTypeIcon(item.vbDocProcessType)-->
      <!--                        ]"-->
      <!--                      ></i>-->
      <!--                      <span>-->
      <!--                        {{ getProcessTypeLabel(item.vbDocProcessType) }}-->
      <!--                      </span>-->
      <!--                    </el-tag>-->

      <!--                    <el-tag-->
      <!--                      size="mini"-->
      <!--                      class="priority lv2"-->
      <!--                      v-if="-->
      <!--                        item.relationType ===-->
      <!--                          VB_DOC_USER.RELATION_TYPE.NGUOI_DUOC_BCC-->
      <!--                      "-->
      <!--                    >-->
      <!--                      <i class="fas fa-exclamation-triangle"></i>-->
      <!--                      {{ item.vbDocBccInfoId ? "BCC-DT" : "BCC" }}-->
      <!--                    </el-tag>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--            <div class="rightSection flex-row flex__right">-->
      <!--              <div class="theTitle__lv3 flex-row flex__left font-size__small">-->
      <!--                <div class="flex-row flex__right txt-right">-->
      <!--                  <i class="cellIcon color__silver fas fa-clock"></i>-->
      <!--                  {{-->
      <!--                  item.docDate-->
      <!--                  | dateFormatter({-->
      <!--                  nullValue: "-",-->
      <!--                  dateFormat: "DD/MM/YYYY"-->
      <!--                  })-->
      <!--                  }}-->
      <!--                </div>-->
      <!--              </div>-->

      <!--              <div class="theTitle__lv2 flex-row flex__left font-size__small">-->
      <!--                <div class="flex-row flex__left">-->
      <!--                  <displayPeople :name="item.senderName"/>-->
      <!--                </div>-->
      <!--              </div>-->

      <!--              <div-->
      <!--                class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"-->
      <!--              >-->
      <!--                <quahan-time :time="item.sendTime"></quahan-time>-->
      <!--              </div>-->

      <!--              <div-->
      <!--                class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"-->
      <!--              >-->
      <!--                <quahan-time :time="item.deadlineDate"></quahan-time>-->
      <!--              </div>-->

      <!--              <div-->
      <!--                class="theQuickAction flex-row flex__right"-->
      <!--                v-if="!isAutoBcc(item)"-->
      <!--              >-->
      <!--                <el-tooltip content="Chuyển xử lý" placement="top">-->
      <!--                  <i-->
      <!--                    @click.stop="chuyenXuLy(item)"-->
      <!--                    class="action-icon bgAmbient__blue clickable fas fa-arrow-alt-to-right"-->
      <!--                  ></i>-->
      <!--                </el-tooltip>-->
      <!--                <el-tooltip content="Thu hồi" placement="top">-->
      <!--                  <i-->
      <!--                    @click.stop="thuHoi(item)"-->
      <!--                    class="action-icon bgAmbient__red clickable fas fa-undo"-->
      <!--                  ></i>-->
      <!--                </el-tooltip>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->

      <!--          <infinite-loading-->
      <!--            ref="infiniteLoading"-->
      <!--            spinner="spiral"-->
      <!--            @infinite="infiniteHandler"-->
      <!--          >-->
      <!--            <div slot="no-more"></div>-->
      <!--            <div slot="no-results">-->
      <!--              Không có dữ liệu-->
      <!--            </div>-->
      <!--          </infinite-loading>-->
      <!--        </div>-->
      <!--      </VuePerfectScrollbar>-->
    </template>

    <!--    <cxl-vbden-dialog-->
    <!--      :isOpen="isOpenTransferDialog"-->
    <!--      :quote="selectedDoc.quote"-->
    <!--      :incomingProcessId="selectedDoc.vbDocUserVbDocProcessId"-->
    <!--      v-if="isEnableTransferDialog"-->
    <!--      @closed="isEnableTransferDialog = false"-->
    <!--      @closeDialog="isOpenTransferDialog = false"-->
    <!--      @success="chuyenXuLiSuccess"-->
    <!--    />-->

    <!--    <thuHoiDialog-->
    <!--      :isOpen="isOpenThuHoiDialog"-->
    <!--      :vbIncomingProcessId="selectedDoc.vbDocUserVbDocProcessId"-->
    <!--      :nextStep="null"-->
    <!--      v-if="isEnableThuHoiDialog"-->
    <!--      @dialogClosed="isEnableThuHoiDialog = false"-->
    <!--      @closeDialog="-->
    <!--        (isOpenThuHoiDialog = false), (isEnableThuHoiDialog = false)-->
    <!--      "-->
    <!--      @success="vbIncomingProcessThuHoiSuccess"-->
    <!--    />-->
  </page-template>
</template>

<script>
import buildShortNameFilter from "../../filters/buildShortNameFilter";
import InfiniteLoading from "vue-infinite-loading";
import dateFormatter from "../../filters/dateFormatter";
import constants from "../../constants";
import listTemplate from "../common/list";
import headerTemplate from "../../components/header/main-header.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vbDenMixin from "./vbDenMixin";
import utils from "../../services/utils";
import vbIncomingProcessService from "../../services/vbIncomingProcessService";
import VbdenAdvanceSearchDialog from "./components/vbden-advance-search-dialog";
import FilterByStatusHeader from "../doc-out/components/filter-by-status-header";
import QuahanTime from "../doc-out/quahan-time";
import CxlVbdenDialog from "./components/cxl-vbden-dialog";
import vbStepService from "../../services/vbStepService";
import vbDelegateInfoService from "../../services/vbDelegateInfoService";
import errorMessageFilter from "../../filters/errorMessageFilter";
import PageTemplate from "../common/layout/page-template";
import SearchTemplateV2 from "../common/layout/search-template-v2";
import IsSeenTag from "../common/is-seen-tag";
import BreakWordSpan from "../adminstration/ketluan/break-word-span";
import DocPriorityTag from "../common/doc-priority-tag";
import DocProcessTypeTag from "./doc-process-type-tag";
import DocBccTag from "./doc-bcc-tag";

export default {
  components: {
    DocBccTag,
    DocProcessTypeTag,
    DocPriorityTag,
    BreakWordSpan,
    IsSeenTag,
    SearchTemplateV2,
    PageTemplate,
    FilterByStatusHeader,
    VbdenAdvanceSearchDialog,
    CxlVbdenDialog,
    InfiniteLoading,
    listTemplate,
    headerTemplate,
    VuePerfectScrollbar,
    QuahanTime,
    subHeader: () => import("../../components/main/sub-header.vue"),
    createDialog: () => import("./components/CreateDialog.vue"),
    filterByStatus: () => import("./components/filter-by-status-header.vue"),
    SortCaret: () => import("../doc-out/SortCaret"),
    thuHoiDialog: () => import("./components/thuHoiDialog"),
    fileTypeImage: () => import("../common/FileTypeImage"),
    displayPeople: () => import("../common/displayPeople.vue"),
  },

  filters: { dateFormatter, buildShortNameFilter },
  mixins: [vbDenMixin],

  data() {
    return {
      isOpenTransferDialog: false,
      isEnableTransferDialog: false,

      ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
      INCOMING_PROCESS_STATUS: constants.INCOMING_PROCESS_STATUS,
      INCOMING_DOC_STATUS: constants.INCOMING_DOC_STATUS,
      isOpenThuHoiDialog: false,
      isEnableThuHoiDialog: false,
      selectedDoc: null,
      filterOptions: [
        {
          value: constants.VBDEN_CHOXULY_PAGE.FILTER.ALL,
          label: "Tất cả",
          iconClass: null,
        },
        {
          value: constants.VBDEN_CHOXULY_PAGE.FILTER.CHU_TRI,
          label: "Chủ trì",
          iconClass: "fa-user",
        },
        {
          value: constants.VBDEN_CHOXULY_PAGE.FILTER.PHOI_HOP,
          label: "Phối hợp",
          iconClass: "fa-users",
        },
        {
          value: constants.VBDEN_CHOXULY_PAGE.FILTER.NHAN_DE_BIET,
          label: "Nhận để biết",
          iconClass: "fa-info",
        },
      ],
      VB_DOC_USER: constants.VB_DOC_USER,
      tableHeight: null,
    };
  },

  created() {
    this.sort = this.$route.query.sort || "sendTime";
    this.order = this.$route.query.order || "desc";
    this.initQuery();
    this.initSendTimeRange();
  },

  mounted() {
    this.tableHeight =
      window.innerHeight - this.$refs.mainTable.$el.offsetTop - 50;
  },

  computed: {
    status() {
      return [constants.DOC_USER_STATUS.DA_XU_LY];
    },
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
  },

  watch: {
    isOpenTransferDialog(newValue) {
      newValue && (this.isEnableTransferDialog = newValue);
    },

    isEnableTransferDialog(newValue) {
      !newValue && (this.selectedDoc = null);
    },

    isOpenThuHoiDialog(newValue) {
      newValue && (this.isEnableThuHoiDialog = newValue);
    },

    isEnableThuHoiDialog(newValue) {
      !newValue && (this.selectedDoc = null);
    },
  },

  methods: {
    isAutoBcc(item) {
      return (
        item.relationType === constants.VB_DOC_USER.RELATION_TYPE.NGUOI_DUOC_BCC
      );
    },

    chuyenXuLiSuccess() {
      this.isOpenTransferDialog = false;
      this.doSearch();
    },

    chuyenXuLy(item) {
      this.checkUserVbIncomingProcess(item)
        .then((isOk) => isOk && this.checkStep(item.vbStepId))
        .then((isOk) => isOk && this.checkUyQuyen(item.delegateInfoId))
        .then(() => {
          this.selectedDoc = item;
          this.isOpenTransferDialog = true;
        });
    },

    /**
     * check cấu hình luồng có cho phép chuyển tiếp văn bản
     * @param stepId
     */
    checkStep(stepId) {
      return stepId
        ? vbStepService.findById(stepId).then((response) => {
            let step = response.data;
            if (
              !step ||
              step.posType === constants.STEP_POS_TYPE.KET_THUC ||
              step.posType === constants.STEP_POS_TYPE.BOTH
            ) {
              this.$message.error(
                errorMessageFilter({
                  errorCode: "vbIncomingDoc.cxl.vbFlowNotAllow",
                })
              );
              return false;
            } else {
              return true;
            }
          })
        : Promise.resolve(true);
    },

    checkUyQuyen(delegateInfoId) {
      return delegateInfoId
        ? vbDelegateInfoService.findById(delegateInfoId).then((response) => {
            let delegateInfo = response.data;
            if (
              delegateInfo &&
              delegateInfo.fromUserDeptRoleId === this.userDeptRoleId
            ) {
              this.$message.error(
                errorMessageFilter({
                  errorCode: "vbIncomingDoc.cxl.delegateNotAllow",
                })
              );
              return false;
            } else {
              return true;
            }
          })
        : Promise.resolve(true);
    },

    checkUserVbIncomingProcess(userVbIncomingProcess) {
      if (
        userVbIncomingProcess &&
        [
          constants.INCOMING_PROCESS_STATUS.CHO_XU_LY,
          constants.INCOMING_PROCESS_STATUS.DA_XU_LY,
          constants.INCOMING_PROCESS_STATUS.KETTHUC,
        ].indexOf(userVbIncomingProcess.status) !== -1
      ) {
        this.$message.error(
          errorMessageFilter({ errorCode: "vbIncomingDoc.cxl.statusMissMatch" })
        );
        return Promise.resolve(true);
      } else {
        return Promise.resolve(false);
      }
    },

    advanceSearch(event) {
      this.advanceSearch_(event);
      this.initSendTimeRange();
      this.doSearch();
    },

    getProcessTypeIcon(processType) {
      processType = processType ? parseInt(processType) : null;
      if (processType === constants.PROCESS_TYPE.CHUTRI) {
        return "fas fa-user";
      } else if (processType === constants.PROCESS_TYPE.PHOIHOP) {
        return "fas fa-users";
      } else if (processType === constants.PROCESS_TYPE.NHANDEBIET) {
        return "fas fa-info";
      } else {
        return "lv3";
      }
    },

    getProcessTypeLabel(processType) {
      processType = processType ? parseInt(processType) : null;
      if (processType === constants.PROCESS_TYPE.CHUTRI) {
        return "Chủ trì";
      } else if (processType === constants.PROCESS_TYPE.PHOIHOP) {
        return "Phối hợp";
      } else if (processType === constants.PROCESS_TYPE.NHANDEBIET) {
        return "Nhận để biết";
      } else {
        return "-";
      }
    },

    getProcessTypeClass(processType) {
      processType = processType ? parseInt(processType) : null;
      if (processType === constants.PROCESS_TYPE.CHUTRI) {
        return "lv1";
      } else if (processType === constants.PROCESS_TYPE.PHOIHOP) {
        return "lv2";
      } else if (processType === constants.PROCESS_TYPE.NHANDEBIET) {
        return "lv3";
      } else {
        return "lv3";
      }
    },

    loadNextVbIncomingProcesses() {
      vbIncomingProcessService
        .findAll(
          { parentId: this.vbIncomingProcessId },
          { page: 0, size: 1000, order: "updateTime,desc" }
        )
        .then((response) => (this.nextVbIncomingProcesses = response.data));
    },

    viewDetail(item) {
      let query = utils.merge(this.$route.query, {
        vbDocProcessId: item.vbDocUserVbDocProcessId,
      });
      let params = utils.merge(this.$route.params, {
        id: item.vbIncomingDocUserViewKey.id,
      });
      this.$router.push({
        name: "vbDenDaXuLyDetail",
        params: params,
        query: query,
      });
    },

    thuHoi(item) {
      this.selectedDoc = item;
      this.isOpenThuHoiDialog = true;
    },

    vbIncomingProcessThuHoiSuccess() {
      this.isOpenThuHoiDialog = false;
      this.doSearch();
    },
  },
};
</script>
<style scoped>
#searchBox {
  position: relative;
  width: 100%;
}

.advance-search {
  font-size: 17px;
  color: #005eb1;
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}

.icon-very__small {
  height: 14px;
  padding-top: 4px;
}

.icon-info {
  background-color: #f0c330;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-top: -1px;
  margin-left: 2px;
}

.barChart {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/vbDenDaXuLyIndex.vue